import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import {
  aboutUsURL,
  contactUsURL,
  faqsURL,
  homeURL,
  interviewsURL,
  privacypolicyURL,
  reflectionsInnerURL,
  reflectionsURL,
  termsandconditionURL,
} from "./helpers/constants";
import Home from "./pages/Home/Home";
import AboutUs from "./pages/AboutUs/AboutUs";
import ContactUs from "./pages/ContactUs/ContactUs";
// import FAQS from "./pages/FAQs/FAQs";
import Reflections from "./pages/Reflections/Reflections";
import ReflectionsInner from "./pages/ReflectionsInner/ReflectionsInner";
import Inteviews from "./pages/Interviews/Interviews";
import FAQS from "./pages/FAQs/FAQs";
import PrivacyPolicy from "./pages/PirvacyAndTerms/PrivacyPolicy";
import TermsAndConditions from "./pages/PirvacyAndTerms/TermsAndConditions";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import PopUp from "./components/PopUp";

const Routing = () => {
  return (
    <>
      <PopUp />
      <Header />
      <Routes>
        <Route path={homeURL} element={<Home />} />
        <Route path={aboutUsURL} element={<AboutUs />} />
        <Route path={contactUsURL} element={<ContactUs />} />
        <Route path={contactUsURL} element={<ContactUs />} />
        <Route path={reflectionsURL} element={<Reflections />} />
        <Route path={reflectionsInnerURL} element={<ReflectionsInner />} />
        <Route path={interviewsURL} element={<Inteviews />} />
        <Route path={faqsURL} element={<FAQS />} />
        <Route path={privacypolicyURL} element={<PrivacyPolicy />} />
        <Route path={termsandconditionURL} element={<TermsAndConditions />} />
        <Route exact path="/" element={<Home />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <Footer />
    </>
  );
};

export default Routing;
